const pic = require.context("../assets/img/slider", true)

const sliderImage = [
    {
        image:pic(`./shepherd.png`),
        name:"Australian Shepherd",
        first:"Intelillent",
        second:"Active",
        third:"Protective"
    },
    {
        image:pic(`./terrier.png`),
        name:"Airedale Terrier",
        first:"Alert",
        second:"Courageous",
        third:"Confident"
    },
    {
        image:pic(`./roky.png`),
        name:"Rotweiller",
        first:"Alert",
        second:"Obedient",
        third:"Fearless"
    },
    {
        image:pic(`./pastorA.png`),
        name:"Pastor Aleman",
        first:"Alert",
        second:"Energetic",
        third:"Fearless"
    },
    {
        image:pic(`./basenji.png`),
        name:"Basenji",
        first:"Intelligent",
        second:"Energetic",
        third:"Playful"
    },
    {
        image:pic(`./beagle.png`),
        name:"Beagle",
        first:"Intelligent",
        second:"Gentle",
        third:"Amiable"
    },
    {
        image:pic(`./king.png`),
        name:"Cavalier King Charles Spaniel",
        first:"Docile",
        second:"Clever",
        third:"Playful"
    },
    {
        image:pic(`./border.png`),
        name:"Border Collie",
        first:"Tenacious",
        second:"Responsive",
        third:"Keen"
    }
]

export default sliderImage